export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=706dae3c8ab9f0d94b41f0e3a2444e5639cf0a6579&name=pushAdClickData!'